import React from 'react';
import { useTypewriter, Cursor } from 'react-simple-typewriter';
import { FaFacebook, FaTwitter, FaLinkedin } from 'react-icons/fa';
import HomePic from '../../imgs/kenvic.jpg'
import {
  SiTailwindcss,
  SiReact,
  SiJavascript,
  SiAndroidstudio,
  SiFlask,
  SiPython,
  SiAdobepremierepro,
  SiFigma,
  SiCanva,
  SiArduino,
} from 'react-icons/si';
const Banner = () => {
  const [text] = useTypewriter({
    words: [
      'A Fullstack Web Developer.',
      'An Android App Developer.',
      'A Video Editor.',
      'A Content Creator.',
      'A Software Engineer.',
      'A Graphic Designer.',
      'A Data Analyst.'
    ],
    loop: true,
    typeSpeed: 20,
    deleteSpeed: 10,
    delaySpeed: 3000,
  });
  return (
    <section
      id='home'
      className='w-full pt-10 pb-20 mt-25 flex flex-col gap-10 lgl:flex-row  xl:gap-0 items-center font-titleFont border-b-[1px] border-b-black '
    >
      {/* For the left homepage */}

      <div className='w-full p-5 lgl:w-1/2 flex flex-col gap-10'>
        <div className='flex flex-col gap-2 lgl:gap-5'>
          <h4 className='text-lg font-normal'>WElCOME TO MY WORLD</h4>
          <h1 className='text-6xl font-bold text-white'>
            HI! I'm{' '}
            <span className='text-designColor Capitalize'>Victor Leo Okeke</span>
          </h1>
          <h2 className='text-4xl font-bold'>
            <span> {text} </span>
            <Cursor
              cursorBlinking='false'
              cursorStyle='|'
              cursorColor='#ff014f'
            />
          </h2>
          <p className='text-base font-bodyFont loading-6 tracking-wide'>
            A Professional web developer, graphic designer, video editor, data analyst, business development officer and an android app developer. A
            software engineer, a graduate of Electronic and Computer Engineering,
            UNN.
          </p>
        </div>
        <div className='flex flex-col gap-10 lgl:flex-row  lgl:gap-0 lgl:justify-between'>
          <div className='lgl:mb-4 lgl:mt-10 mt-5'>
            <h2 className='text-base font-titleFont  mb-4 lgl:mb-[3rem]'>FIND ME IN</h2>
            <div className='flex gap-4 '>
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex item-center justify-center rounded-full shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor cursor-pointer duration-300'>
                <a href="https://www.facebook.com/victor.okeke.39589" target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebook className='w-10 h-10' /></a>
              </span>
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex item-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor cursor-pointer duration-300'>
                <a href="https://x.com/KenvicLeo" target="_blank" rel="noopener noreferrer" aria-label="Twitter"><FaTwitter className='w-10 h-10' /></a>
              </span>
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex item-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor cursor-pointer duration-300'>
                <a href="https://www.linkedin.com/in/victor-okeke-9450ba378" target="_blank" rel="noopener noreferrer" aria-label="Linkedin"><FaLinkedin className='w-10 h-10' /></a>
              </span>
            </div>
          </div>
          <div>
            <h2 className='text-base font-titleFont font-semibold mb-5 lgl:mb-[3rem] lgl:mt-10'>
              SKILL
            </h2>
            <div className='flex gap-4 '>
              <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiReact className='w-10 h-10' />
              </span>
              
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                React
              </span>
            </div>
            <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiAndroidstudio className='w-10 h-10' />
              </span>
              
              <span className="absolute z-[30] bottom-full mb-2 w-[125px] left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Android Studio
              </span>
            </div>
              
              <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiJavascript className='w-10 h-10' />
              </span>
              
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Javascript
              </span>
            </div>
              <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiTailwindcss className='w-10 h-10' />
              </span>
              
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Tailwindcss
              </span>
            </div>
            <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-full shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiCanva className='w-10 h-10' />
              </span>
              
              <span className="absolute bottom-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Canva
              </span>
            </div>
            </div>
            <div className='flex gap-4 mt-4'>
              <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiFlask className='w-10 h-10' />
              </span>
              
              <span className="absolute top-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Flask
              </span>
            </div>
              <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiPython className='w-10 h-10' />
              </span>
              
              <span className="absolute top-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Python
              </span>
            </div>
            <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiAdobepremierepro className='w-10 h-10' />
              </span>
              
              <span className="absolute top-full mb-2 w-[160px] left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Adobe Premiere Pro
              </span>
            </div>
              
             <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiFigma className='w-10 h-10' />
              </span>
              
              <span className="absolute top-full mb-2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Figma
              </span>
            </div>
            <div className="relative group">
              <span className='bannerIcon w-10 h-10 bg-black bg-opacity-25 text-gray-200 text-xl inline-flex items-center justify-center rounded-md shadow-shadowOne hover:bg-opacity-40 hover:-translate-y-1 transition-all hover:text-designColor duration-300'>
                <SiArduino className='w-10 h-10' />
              </span>
              
              <span className="absolute top-full left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 text-sm text-white bg-gray-800 px-2 py-1 rounded-md transition-opacity duration-300">
                Arduino
              </span>
            </div>
            </div>
          </div>
        </div>
      </div>

      {/* For the right homepage */}
      <div className='flex relative w-full  lgl:w-1/2 justify-center items-center'>
        <div className='flex relative group button-0 justify-center items-center'>
          <div className='absolute button-0 w-[320px] h-[420px] lgl:w-[370px] lgl:h-[570px]  shadow-shadowOne flex rounded-full group group-hover:bg-designColor duration-300 '></div>
          <div className=' group-hover:bg-designColor w-[300px] h-[400px] lgl:w-[350px] lgl:h-[550px] rounded-full z-10 mt-1rem overflow-hidden'>
            <img
              className='object-cover'
              src={HomePic}
              alt='Home Portrait'
                />
          </div>
          
        </div>
      </div>
    </section>
  );
};
export default Banner;
